export default "__VITE_ASSET__uJAiC1Qp__"